import { createContext, useContext, useEffect, useState } from "react";

const LanguageContext = createContext();
export const useLanguage = () => {
  return useContext(LanguageContext);
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState("text_en");
  useEffect(() => {
    if (localStorage.getItem("preferredLanguage") != null) {
      setLanguage(localStorage.getItem("preferredLanguage"));
    } else setLanguage("text_en");
  }, []);

  const changeLanguage = (newLanguage) => {
    setLanguage(newLanguage);
    localStorage.setItem("preferredLanguage", newLanguage);
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};
